module.exports = __webpack_public_path__ + "static/media/shape.3ec3a2d7.svg";